(() => {
  if (window.ppProductCardsReady) return;
  window.ppProductCardsReady = true;
  const requests = new WeakMap();
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-pp-volume]');
    const card = link?.closest('[data-pp-card]');
    if (!card || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-current') === 'true') return;
    requests.get(card)?.abort();
    const controller = new AbortController();
    requests.set(card, controller);
    card.setAttribute('aria-busy', 'true');
    const url = new URL(link.href);
    if (url.origin !== location.origin) return;
    url.searchParams.set('section_id', 'pp-product-card-render');
    try {
      const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
      if (!response.ok) throw new Error('card');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.querySelector('[data-pp-card]');
      if (!next) throw new Error('card');
      if (!card.isConnected || controller.signal.aborted) return;
      next.className = card.className;
      if (card.dataset.hideQuickBuy === 'true') next.querySelectorAll('.pp-product-card__form,.pp-product-card__choose').forEach(el => el.remove());
      if (card.dataset.showStock === 'false') next.querySelector('.pp-voorraadstatus-aantal')?.remove();
      next.dataset.hideQuickBuy = card.dataset.hideQuickBuy;
      next.dataset.showStock = card.dataset.showStock;
      card.replaceWith(next);
      next.querySelector('[data-pp-volume][aria-current="true"]')?.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('pp:content:updated', { detail: { root: next } }));
    } catch (error) {
      if (error.name !== 'AbortError') location.assign(link.href);
    } finally {
      if (requests.get(card) === controller) { card.removeAttribute('aria-busy'); requests.delete(card); }
    }
  });
})();
